var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXingCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 0H0v22h22V0zM6.8 9.6 5.6 7.4c-.3-.4.1-.8.4-.8h1.9c.2 0 .3.1.4.2l1.5 2.8c.1.2.1.4 0 .5l-2 3.4c-.2.1-.3.2-.5.2H5.5c-.4 0-.7-.5-.5-.9L6.8 10zm2.9 3.3c-.1-.2-.1-.4 0-.5l4.5-7.9c.1-.2.3-.3.5-.3h2c.3 0 .6.4.3.8l-4.2 7.4c-.1.2-.1.3 0 .4l2.5 4.3c.2.4-.1.9-.5.9h-2c-.2 0-.4-.1-.5-.2z"
})));
export default SvgXingCircle;